import * as actionTypes from "../actions/actionTypes";
import { updateObject } from '../../utils/updateObject';

const INITIAL_STATE = {
  printerList: [],
};

const addEquip = (state, action) => {
  let arr = [...state.printerList];
  if (arr.filter(equip => equip._id === action.equip._id).length === 0) {
    arr.push(action.equip);
  } else {
    const arrFiltered = arr.filter(equip => equip._id !== action.equip._id)
    arr = [...arrFiltered]
  }

  return updateObject(state, { printerList: arr })
}

const clearEquip = (state, action) => {
  return updateObject(state, { printerList: [] })
}


const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionTypes.PRINTER_ADD_EQUIP: return addEquip(state, action);
    case actionTypes.PRINTER_CLEAR_EQUIP: return clearEquip(state, action);
    default:
      return state
  }
}

export default reducer;